import axios from 'axios';
import React, { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import { API } from '../../../config/API';
import ToastComp from '../../../components/Toast/Toast';
import Loader from '../../../components/Loader/Loader';
import toast from 'react-hot-toast';

function AddTraining(arg) {
  const [show, setShow] = useState(arg.flag);
  const [expiryDate, setExpiryDate] = useState(new Date(new Date().setFullYear(new Date().getFullYear() + 1)));
  const [todayDate, setTodayDate] = useState(new Date());
  const [title,setTitle] = useState("");
  const [desc,setDesc] = useState("");
  const [loader, setLoader] = useState(false);
  const [addAlert, setAddAlert] = useState(false);
  const [errorToggle, setErrorToggle] = useState(false);
  const checkFlag = useRef(0);


  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);
  

  //edit training
  const editTraining=()=>{
    const req = {
      id:arg.data.id,
      name: (title===''?arg.data.name:title),
      description: (desc===''?arg.data.desc:desc),
      validfrom: arg.data.validfrom,
      validto: expiryDate.toISOString().split('T')[0]
    };
    if(checkFlag.current === 0){
      req.validto = arg.data.validto;
    }
    setShow(false);
    setLoader(true);

    axios.post(API.editTraining,req).then((res)=>{
      //setLoader(false);
      if(res.data && res.data.status === "S"){
        // setAddAlert(true);        
        toast.success('Edited successfully.');
      }else{
        // setErrorToggle(true);
        toast.error('Failed to edit.');
      }
    }).catch((er)=>{
      //setLoader(false);
      // setErrorToggle(true);
      toast.error('An error occurred while editing training.');
    }).finally(()=>{
      setTimeout(() => {
        setLoader(false)
        arg.callback();
      }, 1000);
    });
  }
  
  //Save new training
  const createTraining =()=>{

    const req = {
      name: title,
      description: desc,
      validfrom: new Date().toISOString().split('T')[0],
      validto: expiryDate.toISOString().split('T')[0]
    };
   
    setShow(false);
    setLoader(true);

    axios.post(API.saveTraining,req).then((res)=>{
      //setLoader(false);
      if(res.data && res.data.status === "S"){
        // setAddAlert(true);      
        toast.success('Training created successfully.');  
      }else{
        // setErrorToggle(true);
        toast.error('Failed to create training.');
      }
    }).catch((er)=>{
      //setLoader(false);
      setErrorToggle(true);
    }).finally(()=>{
      setTimeout(() => {
        setLoader(false)
        arg.callback();
      }, 1000);
    });

  }
  //edit questions
  const editQuestions=()=>{
    arg.editQ();
  }

  return (
    <>
      <Loader loading={loader}></Loader>
      {addAlert ? <ToastComp case='add-training' handler={()=>{setAddAlert(false)}}/> : ""}
      {errorToggle ? <ToastComp case='error' handler={()=>{setErrorToggle(false)}}/> : ""}
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>{arg.edit ? "Edit Training" : "Add New Training"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Title</Form.Label>
              <Form.Control type="text" value={title!==''?title:(arg.edit ? arg.data.name : title)} onChange={(e)=>setTitle(e.target.value)}/>
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={2} value={desc!==''?desc:(arg.edit?arg.data.description:desc)} onChange={(e)=>setDesc(e.target.value)}/>
            </Form.Group> 
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Expiry Date</Form.Label>
              <DatePicker dateFormat="yyyy/MM/dd" minDate={todayDate} selected={(arg.edit && checkFlag.current===0)?new Date(arg.data.validto):expiryDate} onChange={(date) =>{ checkFlag.current=1; setExpiryDate(date)}} className='form-control'/>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
        {
            arg.edit ? <Button variant="warning" onClick={editQuestions} >
            EDIT QUESTIONS
          </Button> : ''
          }
          <Button variant="secondary" onClick={handleClose}>
            CANCEL
          </Button>
         
          {arg.edit ?  <Button variant="primary" onClick={editTraining}>
            EDIT
          </Button>
          :
          <Button variant="primary" onClick={createTraining}>
          SAVE
          </Button>
          }
         
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddTraining;

